import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
    selector: 'app-flight-plan-warnings',
    templateUrl: './flight-plan-warnings.component.html',
    styleUrls: ['./flight-plan-warnings.component.scss'],
    standalone: false
})
export class FlightPlanWarningsComponent implements OnInit {
  public warnings: string[] = [];
  public warningList: string[] = [];
  constructor(private modalCntrl:ModalController) { }

  public ngOnInit() {
    this.warningList = this.warnings.map((warning: string) => warning.trim() );
  }

  public dismiss(){
    this.modalCntrl.dismiss();
  }
}
